module.exports = __webpack_public_path__ + "media/music/drumkit_6-5474cf21.mp3";